export default {
  common: {
    yes: "Yes",
    no: "No",
    ok: "OK",
    cancel: "Cancel",
    close: "Close",
    save: "Save",
    delete: "Delete",
    edit: "Edit",
    add: "Add",
    remove: "Remove",
    clear: "Clear",
    loading: "Loading...",
    error: "Error",
    success: "Success",
    confirm: "Confirm",
    back: "Back",
    next: "Next",
    help: "Help",
    day: "Day",
  },

  timer: {
    minutes: "Minutes",
    start: "Start",
    pause: "Pause",
    reset: "Reset",
  },

  menu: {
    title: "Menu",
    grimoire: "Grimoire",
    townSquare: "Town Square",
    nightOrder: "Night Order",
    characterReference: "Character Reference",
    gameState: "Game State",
    edition: "Edition",
    roles: "Roles",
    fabled: "Fabled",
    session: "Live Session",
    settings: "Settings",
    about: "About",
  },

  roles: {
    townsfolk: "Townsfolk",
    outsider: "Outsider",
    minion: "Minion",
    demon: "Demon",
    traveler: "Traveler",
    fabled: "Fabled",
    bluff: "Demon Bluff",
    firstNight: "First Night",
    otherNight: "Other Night",
    ability: "Ability",
    setup: "Setup",
  },

  player: {
    players: "Players",
    name: "Name",
    role: "Role",
    dead: "Dead",
    alive: "Alive",
    usedAbility: "Used Ability",
    isDead: "Is Dead",
    isVoteless: "Is Voteless",
    pronouns: "Pronouns",
    addPlayer: "Add Player",
    removePlayer: "Remove Player",
    clearPlayers: "Clear Players",
    randomizeSeating: "Randomize Seating",
    swap: "Swap",
    move: "Move",
    emptySeatName: "Empty Seat",
    // Player card menu items
    changePronouns: "Change Pronouns",
    rename: "Rename",
    movePlayer: "Move player",
    swapSeats: "Swap seats",
    emptySeat: "Empty seat",
    vacateSeat: "Vacate seat",
    seatOccupied: "Seat occupied",
    privateChat: "Private Chat",
    // Tooltips
    handUp: "Hand UP",
    handDown: "Hand DOWN",
    swapSeatsTooltip: "Swap seats with this player",
    movePlayerTooltip: "Move player to this seat",
    nominatePlayerTooltip: "Nominate this player",
    ghostVote: "Ghost vote",
    // Prompts
    playerPronounsPrompt: "Player pronouns",
    playerNamePrompt: "Player name",
    // Confirm messages
    confirmEmptySeat: "Empty this seat?",
    confirmRemovePlayer: "Remove this player?",
  },

  voting: {
    vote: "Vote",
    votes: "Votes",
    handUp: "Hand Up",
    handDown: "Hand Down",
    nomination: "Nomination",
    nominate: "Nominate",
    nominee: "Nominee",
    nominator: "Nominator",
    voteHistory: "Vote History",
    votingInProgress: "Voting in Progress",
    votingSpeed: "Voting Speed",
    locked: "Locked",
    exile: "Exile",
    execute: "Execute",
    majority: "Majority",
    votesToTie: "Votes to Tie",
    votesToExecute: "Votes to Execute",
    // Vote component
    nominated: "nominated",
    inFavor: "in favor",
    majorityIs: "majority is",
    timePerPlayer: "Time per player",
    countdown: "Countdown",
    start: "Start",
    restart: "Restart",
    pause: "Pause",
    resume: "Resume",
    reset: "Reset",
    markForExecution: "Mark for execution",
    clearMark: "Clear mark",
    pleaseClaimSeat: "Please claim a seat to vote.",
    secondsBetweenVotes: "seconds between votes",
    // Vote History Modal
    clearVoteHistory: "Clear vote history",
    accessibleToPlayers: "Accessible to players",
    clearForEveryone: "Clear for everyone",
    time: "Time",
    type: "Type",
    voters: "Voters",
  },

  session: {
    liveSession: "Live Session",
    host: "Host",
    join: "Join",
    leave: "Leave",
    sessionId: "Session ID",
    playerCount: "Player Count",
    connecting: "Connecting...",
    reconnecting: "Reconnecting...",
    connected: "Connected",
    disconnected: "Disconnected",
    spectator: "Spectator",
    claimSeat: "Claim Seat",
    distributeRoles: "Distribute Roles",
    sendToPlayer: "Send to Player",
    // Menu prompts and messages
    recentNomination: "recent nomination",
    recentNominations: "recent nominations",
    otherPlayersInSession: "other players in this session",
    msLatency: "ms latency",
    enterChannelHost: "Enter a channel number / name for your session",
    enterPlayerCount: "Enter the number of players (5-20)",
    invalidPlayerCount:
      "Invalid player count. Please enter a number between 5 and 20.",
    createRoom: "Create Room",
    enterRoomNumber: "Enter Room Number",
    roomNumberPlaceholder: "e.g., 1196",
    playerCountPlaceholder: "5-20",
    errorEmptyRoomNumber: "Room number cannot be empty",
    enterChannelJoin:
      "Enter the channel number / name of the session you want to join",
    sessionIdPlaceholder: "Room number or URL",
    joinSession: "Join Game",
    confirmDistributeRoles:
      "Do you want to distribute assigned characters to all SEATED players?",
    confirmLeaveSession: "Are you sure you want to leave the active live game?",
    dissolveRoom: "Dissolve Room",
    confirmDissolveRoom:
      "Are you sure you want to dissolve the room? This will clear all game data.",
    joinDiscord: "Join Discord",
    sourceCode: "Source code",
    storyteller: "Storyteller",
    storytellerAbility: "The game host",
    // Send bluffs feature
    sendBluffs: "Send Bluffs",
    sendBluffsTo: "Send Bluff Roles To:",
    sendBluffsOptions: {
      demon: "Send to Demon",
      lunatic: "Send to Lunatic",
      spy: "Send to Spy",
      bySeatNumber: "Send by Seat Number",
    },
    alsoSendBluffsToDemon: "Also send bluffs to demon (or lunatic)?",
    noDemonFound: "No demon found in the game",
    noLunaticFound: "No lunatic found in the game",
    noSpyFound: "No spy found in the game",
    enterSeatNumber: "Enter seat number (1-{count}):",
    seatNotOccupied: "This seat is not occupied",
    invalidSeatNumber: "Invalid seat number",
    bluffsReceived: "Bluff Roles Received",
  },

  gameState: {
    export: "Export Game State",
    import: "Import Game State",
    copyToClipboard: "Copy to Clipboard",
    pasteFromClipboard: "Paste from Clipboard",
    downloadJSON: "Download JSON",
    uploadJSON: "Upload JSON",
  },

  edition: {
    selectEdition: "Select Edition",
    troubleBrewing: "Trouble Brewing",
    badMoonRising: "Bad Moon Rising",
    sectsAndViolets: "Sects & Violets",
    custom: "Custom Script",
    uploadScript: "Upload Custom Script",
    level: {
      beginner: "Beginner",
      intermediate: "Intermediate",
      veteran: "Veteran",
    },
  },

  settings: {
    background: "Background Image",
    zoom: "Zoom",
    muted: "Muted",
    staticBackground: "Static Background",
    publicTownSquare: "Public Town Square",
    nightMode: "Night Mode",
    imageOptIn: "Show Custom Images",
    language: "Language",
    toggleGrimoire: "Toggle Grimoire/Town Square",
    nickname: "Nickname",
    notSet: "Not Set",
    clearStorage: "Clear Storage",
    // Prompts
    enterBackgroundUrl: "Enter custom background URL",
    enterNickname: "Enter your nickname",
    confirmImageOptIn:
      "Are you sure you want to allow custom images? A malicious script file author might track your IP address this way.",
    confirmRandomizeSeating: "Are you sure you want to randomize seatings?",
    confirmClearRoles: "Are you sure you want to remove all player roles?",
    confirmClearStorage:
      "Are you sure you want to clear all local storage data? This will remove all settings, game data, and nicknames, and refresh the page.",
    enterPlayerName: "Player name",
  },

  modal: {
    reference: {
      title: "Character Reference",
      jinx: "Jinxed",
      selectAll: "Select All",
    },
    nightOrder: {
      title: "Night Order",
      firstNight: "First Night",
      otherNights: "Other Nights",
    },
    reminder: {
      title: "Add Reminder",
      customReminder: "Custom Reminder",
      addCustom: "Add Custom Reminder",
    },
    role: {
      title: "Choose Role",
      search: "Search roles...",
    },
  },

  messages: {
    confirmRemovePlayer: "Remove this player?",
    confirmClearPlayers: "Clear all players?",
    confirmClearRoles: "Clear all roles?",
    missingRoles: "Missing roles: {roles}",
    sessionError: "Session connection error",
    invalidGameState: "Invalid game state data",
    copiedToClipboard: "Copied to clipboard!",
  },

  intro: {
    welcome: "Welcome to Blood on the Clocktower",
    description:
      "An unofficial online tool to run Blood on the Clocktower games",
    start: "Start Game",
    hostGame: "Host Game",
    joinGame: "Join Game",
    // Intro page
    welcomeToUnofficial: "Welcome to the (unofficial)",
    virtualTownSquare: "Virtual Town Square and Grimoire",
    forBloodOnClockTower: "for Blood on the Clocktower!",
    pleaseAddPlayers: "Please add more players through the",
    onTopRight: "on the top right or by pressing",
    canAlsoJoin: ". You can also join a game session by pressing",
    projectOpenSource:
      "This project is free and open source and can be found on",
    github: "GitHub",
    notAffiliated:
      '. It is not affiliated with The Pandemonium Institute. "Blood on the Clocktower" is a trademark of Steven Medway and The Pandemonium Institute.',
    chineseVersionPrompt:
      "Do you want to use the Chinese version of the Grimoire?",
  },

  townInfo: {
    pleaseAddMorePlayers: "Please add more players!",
    by: "by",
    nightPhase: "Night phase",
  },

  townSquare: {
    otherCharacters: "Other characters",
    demonBluffs: "Demon bluffs",
    fabled: "Fabled",
    firstNight: "First Night",
    otherNights: "Other Nights",
    removePlayer: "Remove Player",
    confirmRemovePlayer: "Do you really want to remove",
  },

  chat: {
    privateChatTitle: "Private Chat",
    privateChatWith: "Chat with",
    noMessages: "No messages yet",
    typeMessage: "Type a message...",
    send: "Send",
    chatWithStoryteller: "Chat with Storyteller",
    cancel: "Cancel",
    screenshotTimer: "Timer (auto-expire)",
    screenshotRevoke: "Manual revoke",
    screenshotTTL: "Duration:",
    screenshotSeconds: "s",
    screenshotSecondsLeft: "s left",
    sendScreenshot: "Send Screenshot",
    screenshotExpired: "Screenshot expired",
    screenshotLabel: "Grimoire Screenshot",
    screenshotView: "View",
    screenshotViewAgain: "View Again",
    screenshotViewTime: "You have {seconds}s to view",
    screenshotRevokeBtn: "Revoke",
    screenshotTapToClose: "Tap anywhere to close",
  },

  modals: {
    edition: {
      selectEdition: "Select an edition:",
      loadCustomScript: "Load custom script / characters",
      popularScripts: "Some popular custom scripts:",
      customScriptCharacters: "Custom Script / Characters",
      uploadJSON: "Upload JSON",
      enterURL: "Enter URL",
      useClipboard: "Use JSON from Clipboard",
      customScriptInstructions:
        "To play with a custom script, you need to select the characters you want to play with in the official",
      scriptTool: "Script Tool",
      andUpload:
        'and then upload the generated "custom-list.json" either directly here or provide a URL to such a hosted JSON file.',
      customCharacterInstructions:
        "To play with custom characters, please read",
      theDocumentation: "the documentation",
      onHowToWrite: "on how to write a custom character definition file.",
      warningTrustSource:
        "Only load custom JSON files from sources that you trust!",
      errorReading: "Error reading custom script:",
      enterURLPrompt: "Enter URL to a custom-script.json file",
      errorLoading: "Error loading custom script:",
      pasteScriptPrompt: "Clipboard API is not available in HTTP mode. Please paste your script JSON here:",
      pasteScriptTitle: "Paste Script JSON",
      pasteScriptPlaceholder: "Paste your script JSON here...",
    },
    roles: {
      selectCharacters: "Select the characters for {count} players:",
      warningSetupRoles:
        "Warning: there are characters selected that modify the game setup! The randomizer does not account for these characters.",
      allowDuplicates: "Allow duplicate characters",
      assignRandomly: "Assign {count} characters randomly",
      shuffleCharacters: "Shuffle characters",
    },
    reference: {
      showNightOrder: "Show Night Order",
      characterReference: "Character Reference",
      customScript: "Custom Script",
      jinxed: "Jinxed",
    },
    gameState: {
      currentGameState: "Current Game State",
      copyJSON: "Copy JSON",
      loadState: "Load State",
      unableToParse: "Unable to parse JSON:",
    },
    nightOrder: {
      showCharacterReference: "Show Character Reference",
      nightOrder: "Night Order",
      customScript: "Custom Script",
      firstNight: "First Night",
      otherNights: "Other Nights",
      minionInfo: "Minion info",
      demonInfo: "Demon info & bluffs",
      minionReminder1:
        "• If more than one Minion, they all make eye contact with each other. ",
      minionReminder2:
        '• Show the "This is the Demon" card. Point to the Demon.',
      demonReminder1:
        '• Show the "These are your minions" card. Point to each Minion. ',
      demonReminder2:
        '• Show the "These characters are not in play" card. Show 3 character tokens of good characters not in play.',
      cardThisIsDemon: "This is the Demon",
      cardTheseAreMinions: "These are your minions",
      cardNotInPlay: "These characters are not in play",
    },
    reminder: {
      chooseReminder: "Choose a reminder token:",
      good: "Good",
      evil: "Evil",
      customNote: "Custom note",
      addCustomReminder: "Add a custom reminder note",
    },
    role: {
      chooseCharacterFor: "Choose a new character for",
      bluffing: "bluffing",
      editionRoles: "Edition Roles",
      otherTravelers: "Other Travelers",
      showAllRoles: "Show all roles (including roles in play)",
    },
    fabled: {
      chooseFabled: "Choose a fabled character to add to the game",
    },
  },
};
